import { GeneratePageParams } from "routes/interfaces";

export default [
	{
		pageDirPath: '/checkout/OrderRevision',
		title: 'Revisar pedido',
		pathname: '/revisar-pedido',
		headerType: 'home',

		type: 'PRIVATE',
		needContext: 'POS',
		allowedRestrictions: ['SIMULATED', 'PARTNER'],
	},
	{
		pageDirPath: '/checkout/Success',
		title: 'Pedido confirmado',
		pathname: '/pedido-finalizado/:posId/:closedBasketGroupId',
		headerType: 'home',

		type: 'PRIVATE',
		needContext: 'POS',
		allowedRestrictions: ['SIMULATED', 'PARTNER'],
	},
] satisfies GeneratePageParams[];
